export interface ConsultationData {
    userId: string;
    token: string;
    locator: string;
    consultationId: string;
    displayName: string;
    isCaregiverView: boolean;
    phoneCallsEnabled: boolean;
    videoSessionUid: string;
    skipDeviceSetup: boolean;
    isSetupOnly: boolean;
    handledBy: string;
    isInternalCall: boolean;
}

export const CallEndedMessage = 'call-ended';
